import type BaseLayer from 'ol/layer/Base.js';
import type OlMap from 'ol/Map.js';
import type MapEvent from 'ol/MapEvent.js';

/** Removed layers can remain in the last frame used for picking and font redraw. */
export function disposeRemovedLayer(map: OlMap, layer: BaseLayer): void {
  if (!map.isRendered()) { layer.dispose(); return; }
  const afterRender = (event: MapEvent) => {
    if (event.frameState?.layerStatesArray.some(state => state.layer === layer)) return;
    map.un('postrender', afterRender);
    layer.dispose();
  };
  map.on('postrender', afterRender);
}
